module.exports = __webpack_public_path__ + "img/mergdata_paper_wireframe.e3f94ec1.png";